import { ChatService } from '../chat.service';
import { Component, Input } from '@angular/core';
import { Region } from '../../shared/models';

@Component({
    selector: 'region-element',
    styles: [ require('./region-element.component.scss')],
    template: require('./region-element.component.pug')
})
export class RegionElementComponent {
    @Input() region: Region;

    constructor(private _chatService: ChatService) { }

    join(region: Region) {
        this._chatService.pushChatCommand({id: 'joinRegion', data: region});
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/chat/region-element/region-element.component.ts